import { PartiesPage } from '../parties/PartiesPage';

/**
 * Lead Master — the Party Master list locked to Lead-type parties. Reuses
 * PartiesPage in "leads" mode so the two stay in sync (columns, Convert,
 * Edit, Delete, Export/Import) without duplicating the list logic.
 */
export function LeadMasterPage() {
  return <PartiesPage mode="leads" />;
}
